import clsx from "clsx";
import { Button, Stack, Typography } from "@mui/material";

export type TButtonIconTextProps = {
	icon: React.ReactNode;
	iconHover?: React.ReactNode;
	value?: string | null;
	disabled?: boolean;
	onClick?: (value?: string | null) => void;
	className?: string;
	typographyClassName?: string;
};

export default function ButtonIconText(props: Readonly<TButtonIconTextProps>) {
	const handleClick = () => {
		if (props.onClick) {
			props.onClick(props.value);
		}
	};

	return (
		<Button
			className={clsx({
				[props?.className ?? ""]: !!props?.className,
				"simple-icon-button": true,
			})}
			disabled={props.disabled}
			sx={{ textTransform: "capitalize", height: "fit-content" }}
			onClick={handleClick}
		>
			<Stack position="relative" width={"100%"}>
				<>
					<Stack width={"100%"} className={"regular-icon"}>
						{props.icon}
					</Stack>
					{props.iconHover ? (
						<Stack width={"100%"} className={"hover-icon"}>
							{props.iconHover}
						</Stack>
					) : (
						<Stack width={"100%"} className={"hover-icon"}>
							{props.icon}
						</Stack>
					)}
				</>

				{props?.value && (
					<Typography
						mt={1}
						variant="body2"
						className={
							props.typographyClassName ??
							"button-icon-text !font-montserrat !font-medium !text-xs text-center text-gray-text"
						}
					>
						{props.value}
					</Typography>
				)}
			</Stack>
		</Button>
	);
}
